const maskObject: object = {
    phone: {
        mask: '(000) 000-0000',
        pattern: '^\\((\\d{3})\\) (\\d{3})-(\\d{4})',
        um_pattern: '(\\d{3})(\\d{3})(\\d{4})',
        type: 'tel',
        mode: 'tel',
        classNames: ''
    },
    currency: {
        pattern: '^\\$?(([1-9](\\d*|\\d{0,2}(,\\d{3})*))|0)(\\.\\d{1,2})?$',
        um_pattern: '^(([1-9](\\d*|\\d{0,2}(,\\d{3})*))|0)(\\.\\d{1,2})?$',
        type: 'text',
        mode: 'decimal',
        classNames: 'text-right',
        mask: '$currency'
    },
    hours: {
        pattern: '(\\d{1,2,3}|0)?(\\.\\d{1,2})? hr',
        um_pattern: '(\\d{1,2,3}|0)?(\\.\\d{1,2})?',
        type: 'text',
        mode: 'decimal',
        classNames: 'text-right',
        mask: 'decimal hr'
    },
    percent: {
        pattern: '(\\d{1,2,3}|0)? %',
        um_pattern: '(\\d{1,2,3}|0)?',
        type: 'text',
        mode: 'decimal',
        classNames: 'text-right',
        mask: 'integer %'
    },
    ssn: {
        mask: '000-00-0000',
        pattern: '(\\d{3})-(\\d{2})-(\\d{4})',
        um_pattern: '(\\d{3})(\\d{2})(\\d{4})',
        type: 'text',
        mode: 'number',
        classNames: ''
    },
    ein: {
        mask: '00-0000000',
        pattern: '(\\d{2})-(\\d{7})',
        um_pattern: '(\\d{2})(\\d{7})',
        type: 'text',
        mode: 'number',
        classNames: ''
    },
    zip: {
        mask: '00000-0000',
        pattern: '(\\d{5})(-)(\\d{4})',
        um_pattern: '(\\d{5})(\\d{4})',
        type: 'text',
        mode: 'number',
        classNames: ''
    }
};

export default maskObject;